import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'datetime', standalone: true })
export class DatetimePipe implements PipeTransform {
  transform(dateStr: string | null | undefined): string {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
      + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  }
}
